import { Select } from 'antd'
import React, { useEffect } from 'react'
import { toast } from 'react-toastify'
import { useGetCountriesQuery } from '../redux/apis/utilsManagement/countries/utilsMCountriesApiSlice'

const CountriesDropdown = ({ onChange, onBlur, value }) => {
  const { data, isLoading, error } = useGetCountriesQuery({
    page: '*',
    fields: ['id', 'country_name'].join(',')
  })

  useEffect(() => {
    if (!error && !isLoading) {
      return
    }
    toast.error(error)
  }, [error, isLoading])

  return (
    <div className=' mb-3'>
      <label className='form-label'>Country</label>
      <br />
      <Select
        name='country'
        showSearch
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '')
            .toLowerCase()
            .localeCompare((optionB?.label ?? '').toLowerCase())
        }
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={data?.data?.results?.map(x => {
          return { label: x.country_name, value: x.id }
        })}
      />
    </div>
  )
}

export default CountriesDropdown
